export const SIDEBAR_DIALOG_CONFIG = {
  paddingX: 'px-20',
  dialogClassName: 'z-[20000] fixed right-0 top-0 flex h-full w-[800px] flex-col bg-white shadow-sm',
};
